import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz28 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel29'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel27'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <div class="title">Newspaper Puzzle</div>
   
    <div class="text">
        <p><strong>Question:</strong> A newspaper made of 16 large sheets of paper folded in half. The newspaper has 64
            pages altogether. The first sheet contains pages 1, 2, 63, 64.</p>
     <p>If we pick up a sheet containing page number 45. What are the other pages that this sheet contains?</p>
        <p><br/><br/><br/><br/></p>
        <div class="containers">
        <p><strong>Answer:</strong><br/>On the back of 45, it is 46. The pages are such that for each page p, 65-p will
            be also on the same page.</p><br/>
        <div id="AP_G4GR_5"></div>
      
        <p>Then,<br/>65-45 = 20<br/>65-46 = 19</p>
        <p>So the four pages in this sheet are 19, 20, 45, 46.</p>
     </div>
    </div>
</article>
        </div>
    )
}

export default Puz28
